module.exports = __webpack_public_path__ + "static/media/icon_upload_white.fb28f013.svg";